import { Throbber } from 'app/components/throbber';
import { useI18n } from 'core/hooks/useI18n';
import { Routing } from 'core/routing/Routing';
import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

const Annotations = lazy(() => import('app/views/annotations'));
const MonitorPollutantAnnotation = lazy(() => import('app/views/annotations/components/monitor-pollutant-annotation'));
const DisregardAnnotation = lazy(() => import('app/views/annotations/components/disregard-annotation'));
const AnnotationsListing = lazy(() => import('app/views/annotations/pages/annotations-listing/AnnotationsListing'));
const EditIncidentInvestigationAnnotation = lazy(
  () => import('app/views/annotations/pages/edit-incident-investigation-annotation/EditIncidentInvestigationAnnotation')
);

const routes = Routing.routes.annotations;

export function AnnotationsRoutes() {
  const { l10n } = useI18n('app');

  return (
    <Route
      path={routes.root}
      element={
        <Suspense fallback={<Throbber>{l10n('loading.screen.annotations')}</Throbber>}>
          <Annotations />
        </Suspense>
      }
    >
      <Route
        index
        element={
          <Suspense fallback={<Throbber>{l10n('loading.screen.annotations')}</Throbber>}>
            <AnnotationsListing />
          </Suspense>
        }
      />
      {[
        routes.edit.controlledTest(),
        routes.create.controlledTest(),
        routes.edit.approximateExposure(),
        routes.create.approximateExposure(),
        routes.edit.fieldObservation(),
        routes.create.fieldObservation(),
        routes.edit.odourObservation(),
        routes.create.odourObservation(),
        routes.edit.airQualityObservation(),
        routes.create.airQualityObservation(),
      ].map(path => (
        <Route
          key={path}
          path={path}
          element={
            <Suspense fallback={<Throbber>{l10n('loading.screen.annotations')}</Throbber>}>
              <MonitorPollutantAnnotation />
            </Suspense>
          }
        />
      ))}
      {[routes.edit.disregard(), routes.create.disregard()].map(path => (
        <Route
          key={path}
          path={path}
          element={
            <Suspense fallback={<Throbber>{l10n('loading.screen.annotations')}</Throbber>}>
              <DisregardAnnotation />
            </Suspense>
          }
        />
      ))}
      {[routes.create.incidentInvestigation(), routes.edit.incidentInvestigation()].map(path => (
        <Route
          key={path}
          path={path}
          element={
            <Suspense fallback={<Throbber>{l10n('loading.screen.annotations')}</Throbber>}>
              <EditIncidentInvestigationAnnotation />
            </Suspense>
          }
        />
      ))}
    </Route>
  );
}
